import { render, staticRenderFns } from "./OrderWorklogsTable.vue?vue&type=template&id=3652f026&"
import script from "./OrderWorklogsTable.vue?vue&type=script&lang=ts&"
export * from "./OrderWorklogsTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderWorklogsTable.vue?vue&type=style&index=0&id=3652f026&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports